
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCommonUser} from "@/models/app/common/User";
import {AppCommonMatchCategory} from "@/models/app/common/match-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AdministratorNavigationVue from "@/components/administrator/navigation.vue";
import AdministratorMatchesNavigationVue from "@/components/administrator/matches/navigation.vue";
import AppAdministratorMatchesRootFilterIndexVue from "@/views/app/administrator/matches/root/filter/index.vue";
import AppAdministratorMatchesRootListIndexVue from "@/views/app/administrator/matches/root/list/index.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AdministratorNavigationVue,
    AdministratorMatchesNavigationVue,
    AppAdministratorMatchesRootFilterIndexVue,
    AppAdministratorMatchesRootListIndexVue,
  },
})
export default class AppAdministratorMatchesRootIndexVue extends Vue {
  isLoading: boolean | null = false;

  players: Array<AppCommonUser> = [];
  matchCategories: Array<AppCommonMatchCategory> = [];

  $refs!: {
    AppAdministratorMatchesRootListIndexVue: any;
  };

  getMatchesByFilter(formData: any): void {
    this.$refs.AppAdministratorMatchesRootListIndexVue.getMatches(formData);
  }

  async getPlayers(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/utility/organization-members`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
        role: "player",
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.players = r.data;
      }
    });
    this.isLoading = false;
  }

  async getMatchCategories(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/utility/match-categories`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.matchCategories = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getPlayers();
    await this.getMatchCategories();
  }
}
